import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { BaseChartDirective } from 'ng2-charts/ng2-charts';
import { ReportsService } from '../../../reports/services/reports.service';
import { CookieManagerService } from '../../../../shared/services/cookie-manager.service';
// component

import { Constants } from '../../../../app.const';
import { WorkConstants } from "../../../work/work.const";
import { TranslateService } from 'ng2-translate';
declare var $: any;

@Component({
  selector: 'app-maindashboard',
  templateUrl: './maindashboard.component.html',
  styleUrls: ['./maindashboard.component.css']

})
export class MaindashboardComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  date: string;
  authUser: any = {};
  workConstants: any = WorkConstants;
  attendance_sheets: any = {
    user_name: [],
    user_times: []
  };

  time_sheets: any = {
    user_name: [],
    user_times: []
  };

  leave_sheets: any = {
    user_name: [],
    user_times: []
  };

  dateOfYesterday: Date = new Date();
  lastMonthFirstDate: Date;
  lastMonthLastDate: Date;
  currentMonthFirstDate: Date;
  currentMonthLastDate: Date;
  currentyearFirstDate: Date;
  currentyearLastDate: Date;
  currentDate: Date = new Date();


  private constants = Constants;
  constructor(
    private datePipe: DatePipe,
    private reportsService: ReportsService,
    private cookieManagerService: CookieManagerService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {

    let $this = this;
    let date = new Date();
    this.getAuthUser();
    this.checkAdminUserPermission();
    // define dates
    this.dateOfYesterday.setDate(date.getDate() - 1);
    this.lastMonthFirstDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    this.lastMonthLastDate = new Date(date.getFullYear(), date.getMonth(), 0)
    this.currentMonthFirstDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.currentMonthLastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.currentyearFirstDate = new Date(date.getFullYear(), 0, 1);
    this.currentyearLastDate = new Date(date.getFullYear() + 1, 0, 0);

    // defauld admin chart details for yesterday
    this.getTimeSheetAndAttendanceByDate(this.datePipe.transform(this.dateOfYesterday, this.constants.dateFormat), this.datePipe.transform(this.dateOfYesterday, this.constants.dateFormat));

    // admin chart details
    $('#adminChartDate').val(this.datePipe.transform(date, this.constants.dateFormat));
    $('#adminChartDate').datepicker({
      autoclose: true,
      minViewMode: 0,
      format: this.constants.dateFormatDatepicker,
      endDate: new Date()
    }).on('changeDate', function (selected) {
      let selectDate = new Date(selected.date.valueOf());
      $this.date = $this.datePipe.transform(selectDate, $this.constants.dateFormat);
      // get time sheet on chagne
      $this.getTimeSheetAndAttendanceByDate($this.date, $this.date);
    });
  }

  /**
     * Timesheet time chart
     */
  public timesheetChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public timesheetChartLabels: string[] = [];
  public timesheetChartType: string = 'bar';
  public timesheetChartLegend: boolean = true;

  public timesheetChartData: any[] = [
    { data: [], label: this.translateService.instant('WORKINGhOURS') },
    { data: [], label: this.translateService.instant('ATTENDANCE') },
    { data: [], label: this.translateService.instant('LEAVE') },
  ];

  public timesheetChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(26,179,142,1)', // color of timesheet
      stack: 'timeSheet',
    },
    {
      backgroundColor: '#676a6c', // color of attendance
      stack: 'attendance',
    },
    {
      backgroundColor: '#f8ac59', // color of leave
       stack: 'attendance',
    }
  ];
  // Timesheet chart 

  /**
   * Get timesheet and Attendance by given date for graph  
   * 
   * @param {any} toDate 
   * @param {any} fromDate
   * @memberOf TimesheetComponent
   */
  getTimeSheetAndAttendanceByDate(toDate, fromDate) {
    this.reportsService.getTimeSheetAndAttendanceWithOutShorting({ toDate, fromDate }).subscribe(
      res => {
        this.time_sheets = res.data.time_sheets;
        this.attendance_sheets = res.data.attendance_sheets;
        this.leave_sheets = res.data.leave_sheet;

        this.timesheetChartData = [];
        this.timesheetChartData = [
          { data: this.time_sheets.user_times, label: this.translateService.instant('WORKINGhOURS') },
          { data: this.attendance_sheets.user_times, label: this.translateService.instant('ATTENDANCE') },
          { data: this.leave_sheets.user_times, label: this.translateService.instant('LEAVE') },
        ];
        this.timesheetChartLegend = true;
        this.timesheetChartLabels = [];
        this.timesheetChartLabels = this.time_sheets.user_name;

        if (this.chart && this.chart.chart && this.chart.chart.config) {
          this.chart.chart.config.data.labels = this.time_sheets.user_name;
          this.chart.chart.update();
        }
      }
    );
  }

  showDatePickerInAdminChart() {
    // show custom calander for admin chart
    $('#custom-date').show();
    // add and remove "active" class
    $('#adminChartCustom').addClass('active');
    $('.admin-chart-button').removeClass('active');
  }

  showAdminChartInDateRange(event, toDate, fromDate) {
    // get the id from the event
    var idAttr = event.target.id;
    // hide the calander
    $('#custom-date').hide();
    //remove and add new class
    $('.admin-chart-button').removeClass('active');
    $('#' + idAttr).addClass('active');

    var toDateAttr = this.datePipe.transform(toDate, this.constants.dateFormat);
    var fromDateAttr = this.datePipe.transform(fromDate, this.constants.dateFormat);
    this.getTimeSheetAndAttendanceByDate(toDateAttr, fromDateAttr)
  }

  /**
 * kaushalya
 * 2017-07-03
 * get log user details from the cookies
 */
  getAuthUser() {
    let userToken = this.cookieManagerService.getCookie(WorkConstants.basicConstans.userToken, false);
    this.authUser = JSON.parse(CryptoJS.AES.decrypt(userToken, WorkConstants.basicConstans.userKey).toString(CryptoJS.enc.Utf8));
  }
  /**
   * kaushalya
   * 2017-07-03
   * check adminUser permission for div
   */

  checkAdminUserPermission() {
    if (this.authUser.user_role_id != WorkConstants.basicConstans.adminRoleId && this.authUser.user_role_id != WorkConstants.basicConstans.supervisorRoleId) {
      $('#adminChart').hide();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/maindashboard/maindashboard.component.ts